'use client'
import { useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { ONE } from 'config/apis'
import Form from 'components/Form'
import { sendForm, getRequest } from 'services/private'
import { useMainContext, usePrivateContext } from 'utils/context'
import Title from 'components/privat/Title'
import { GoBackLink } from 'components/GoBack'
import { dateToString } from 'utils/date'
import Button from 'components/Button'
import SubTitle from 'components/privat/SubTitle'

const NewPlayer = () => {
  const [formData, setFormData] = useState({})
  const [formSchema, setFormSchema] = useState([])
  const [sendTheForm, setSendTheForm] = useState(false)
  const [error, setError] = useState('')
  const [finalMsg, setFinalMsg] = useState('')
  const [extraOptions, setExtraOptions] = useState([])
  const [playerNameWithGender, setPlayerNameWithGender] = useState('')
  const [errorsFormElements, setErrorsFormElements] = useState({})
  const { fedId, fedToken } = useMainContext()
  const { fedDetails } = usePrivateContext()
  const [torInfo, setTorInfo] = useState('')
  const pathname = usePathname().split('/')
  const torSlug = pathname[pathname.length - 1]

  const handleSubmit = async () => {
    if (sendTheForm) {
      setFinalMsg('')
      setError('')
      const modFormData = { ...formData }
      modFormData.id_tournament = torInfo.Info.Id
      modFormData.birthDate_J2 = dateToString(modFormData.birthDate_J2).withYear
      modFormData.drawType = 'RANKING'
      modFormData.imageRights = 'SI'
      modFormData.obs = formData.obs || ''
      const response = await sendForm({
        user: fedId,
        token: fedToken,
        formData: modFormData,
        endpoint: 'PRIVATE_TOR_REGISTRATION',
        queryString: `?idtorneo=${torInfo.Info.Id}`
      })
      if (response.resultado === 'OK') {
        setFinalMsg(response?.mensaje)
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
      if (response.resultado === 'ERROR') {
        setError(response.error_desc)
      }
    }
    setSendTheForm(false)
  }

  const validateLicense = async () => {
    const response = await getRequest({
      user: fedId,
      token: fedToken,
      endpoint: 'PRIVATE_TOR_VALIDATION',
      queryString: `?idtorneo=${torInfo.Info.Id}&license=${formData.licence_J2}`
    })
    if (response?.RequiredData) {
      setExtraOptions(response?.RequiredData)
    } else if (response?.resultado === 'ERROR') {
      setErrorsFormElements({ licence_J2: response.error_desc })
    }
  }

  const handleBlur = (e) => {
    if (formData.licence_J2 !== '' && e.target.name === 'licence_J2') {
      validateLicense()
    }
  }

  const getFed = async () => {
    if (fedDetails?.PersonalInformation) {
      const fedData = fedDetails.PersonalInformation
      const gender = fedData.sex === 'M' ? 'JUGADOR' : 'JUGADORA'
      setPlayerNameWithGender(gender)
      setFormData({ email_J1: fedData.email, phone_J1: fedData.phone })
      const form = [
        {
          section: 'CONDICIONS D’INSCRIPCIÓ',
          description:
            "Poden participar tots/es aquells/es jugadors/es que tinguin tramitada la seva llicència federativa correctament. Per poder inscriure's al torneig, cal introduir el número de la teva llicència de jugador/a i del teu company/a"
        },
        {
          section: `${gender} 1 (TU)`,
          description: '',
          className: '',
          fields: [
            {
              id: 'email_J1',
              name: 'Email',
              element: 'input',
              type: 'email',
              defaultValue: fedData.email,
              required: true
            },
            {
              id: 'phone_J1',
              name: 'Telèfon',
              element: 'input',
              type: 'text',
              defaultValue: fedData.phone,
              required: true
            }
          ]
        },
        {
          section: 'titlePlayerTwo',
          description:
            "Omple les següents dades per verificar les dades d'aquest jugador",
          className: 'mt-8',
          fields: [
            {
              id: 'licence_J2',
              name: 'Número de llicència',
              element: 'input',
              type: 'text',
              required: true
            },
            {
              id: 'birthDate_J2',
              name: 'Data Naixement',
              element: 'input',
              type: 'date',
              required: true
            },
            {
              id: 'email_J2',
              name: 'Email',
              element: 'input',
              type: 'email',
              required: true
            },
            {
              id: 'phone_J2',
              name: 'Telèfon',
              element: 'input',
              type: 'text',
              required: true
            }
          ]
        },
        {
          section: 'INFORMACIÓ ADDICIONAL',
          className: 'mt-8',
          fields: [
            {
              id: 'category',
              name: 'Categoria',
              element: 'select',
              required: true,
              showIfDynamicData: 'category',
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityID_J1',
              name: 'Universitat Jugador 1',
              element: 'select',
              required: true,
              showIfDynamicData: 'universityID',
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityCollective_J1',
              name: 'Col·lectiu Jugador 1',
              element: 'select',
              required: true,
              showIfDynamicData: 'universityCollective',
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityCenter_J1',
              name: 'Campus Jugador 1',
              element: 'select',
              required: true,
              dynamicData: 'universityCenter1',
              showIf: [{ name: 'universityCollective_J1', value: 'Estudiant' }],
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityStudy_J1',
              name: 'Jugador 1 - Quin Grau, Màster, Postgrau o Doctorat, estudies? ',
              element: 'input',
              type: 'text',
              required: true,
              showIf: [{ name: 'universityCollective_J1', value: 'Estudiant' }]
            },
            {
              id: 'universityID_J2',
              name: 'Universitat Jugador 2',
              element: 'select',
              required: true,
              showIfDynamicData: 'universityID',
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityCollective_J2',
              name: 'Col·lectiu Jugador 2',
              element: 'select',
              required: true,
              showIfDynamicData: 'universityCollective',
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityCenter_J2',
              name: 'Campus Jugador 2',
              element: 'select',
              required: true,
              dynamicData: 'universityCenter2',
              showIf: [{ name: 'universityCollective_J2', value: 'Estudiant' }],
              options: [],
              createEmptyOption: true
            },
            {
              id: 'universityStudy_J2',
              name: 'Jugador 2 - Quin Grau, Màster, Postgrau o Doctorat, estudies? ',
              element: 'input',
              type: 'text',
              required: true,
              showIf: [{ name: 'universityCollective_J2', value: 'Estudiant' }]
            }
          ]
        },
        {
          section: '',
          description:
            'Observacions: (El jutge àrbitre atendrà les peticions en la mesura del possible)',
          className: 'mt-8',
          fields: [
            {
              id: 'obs',
              element: 'input',
              text: 'text'
            },
            {
              id: 'terms',
              element: 'checkbox',
              text: 'Acepto els termes i la <a target="_blank" className="underline" href="/politica-de-privacitat">política de privacitat</a>',
              description: '',
              // "L’informem que totes les dades proporcionades es tracten sota la responsabilitat de la Federació catalana de Pàdel (FCP), amb la finalitat de gestionar la seva inscripció així com realitzar el manteniment i gestió de la seva relació amb la FCP així com l’enviament d'informació sobre els seus serveis i activitats. Igualment, l'informem que algunes de les dades personals poden incorporar-se a les classificacions dels torneigs organitzats per la FCP en els que els participants participin i ser incloses en la pàgina web de la FCP. La FCP tracta i manté les dades en base a una missió en interès públic, per delegació de l’Administració pública esportiva, execució d’un contracte (llicència federativa), interessos legítims de la FCP, i compliment d’obligacions legals. Informem sobre la possibilitat d'exercir els drets d'accés, rectificació, supressió, limitació i oposició, i revocació de consentiment, mitjançant comunicació adreçada a: FCP, Via Augusta, 13-15 Despatx 108 - 08006 Barcelona, o adreça electrònica - dpd@fcpadel.cat Per qualsevol qüestió sobre el tractament de les dades, poden contactar el delegat de protecció de dades de la FCP a esportiva@fcpadel.cat. Informem del dret de tot interessat a presentar una reclamació davant les autoritats de control de protecció de dades. Dret d’imatge: està previst l’enregistrament i difusió del torneig pels mitjans de comunicació de la FCP (incloent anuaris, pàgina web www.fcpadel.cat, xarxes socials de la FCP, i altres) amb la finalitat de donar a conèixer les nostres activitats i promocionar la pràctica del Pàdel. La inscripció suposa l’acceptació del tractament de la imatge dels participants per aquesta finalitat. En cas de proporcionar dades d’altes participants, la persona que proporciona les dades es compromet personalment a informar del contingut d’aquesta clàusula informativa.",
              required: true
            },
            {
              id: 'submit',
              name: '',
              element: 'Button',
              text: 'Enviar',
              link: '#',
              type: 'submit'
            }
          ]
        }
      ]
      setFormSchema(form)
    }
  }

  const getTorInfo = async () => {
    try {
      const res = await fetch(
        ONE.TOR_INFO.replace('{year}', new Date().getFullYear()).replace(
          '{slug}',
          torSlug
        ),
        ONE.HEADERS
      )
      const parsed = await res.json()
      setTorInfo(parsed.Data)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getTorInfo()
  }, [])

  useEffect(() => {
    getFed()
  }, [fedDetails])

  useEffect(() => {
    handleSubmit()
  }, [sendTheForm])

  return (
    <div className="max-w-xl">
      <GoBackLink url="/privat/federat/competicio/inscripcions-obertes" />
      <Title className="mt-10">{"Formulari d'Inscripció"}</Title>
      {torInfo?.AdditionalInformation?.Image1 && (
        <a
          href={torInfo.AdditionalInformation.Image1}
          target="_blank"
          rel="noreferrer"
        >
          <div className="max-w-[300px] mt-10">
            <img
              className="h-full object-cover"
              src={torInfo.AdditionalInformation.Image1}
            />
          </div>
        </a>
      )}
      {torInfo?.Info && (
        <h4 className="mt-6 font-alliance-medium text-[16px] lg:text-[22px]">
          {torInfo.Info.Name}
          <br />
          {`${dateToString(torInfo.Info.StartDate).withYear} - ${
            dateToString(torInfo.Info.EndDate).withYear
          }`}
        </h4>
      )}
      {finalMsg ? (
        <>
          <p className="text-blue font-alliance-light text-[14px] lg:text-[22px] mt-6 lg:mt-10 mb-20">
            {finalMsg}
          </p>
          <Button
            link="/privat/federat/tramits/pagament-tornejos"
            text="PROCEDIR AL PAGAMENT"
          />
        </>
      ) : (
        <Form
          form={formSchema}
          setSendTheForm={setSendTheForm}
          formData={formData}
          setFormData={setFormData}
          dynamicData={{
            category: extraOptions?.categories?.map(({ Id, Value }) => ({
              value: Id,
              text: Value
            })),
            universityID: extraOptions?.additionalData?.map(({ id, name }) => ({
              value: id,
              text: name
            })),
            universityCollective:
              extraOptions?.additionalData &&
              Object.keys(extraOptions?.additionalData?.[0].collective).map(
                (key) => ({
                  value: key,
                  text: key
                })
              ),
            universityCenter1: extraOptions?.additionalData
              ?.find(({ id }) => id === formData?.universityID_J1)
              ?.collective.Estudiant.map(({ universityCenter, name }) => ({
                value: universityCenter,
                text: name
              })),
            universityCenter2: extraOptions?.additionalData
              ?.find(({ id }) => id === formData?.universityID_J2)
              ?.collective.Estudiant.map(({ universityCenter, name }) => ({
                value: universityCenter,
                text: name
              })),
            titlePlayerTwo: `${playerNameWithGender} 2 ${
              extraOptions?.name
                ? `- ${extraOptions?.name} ${extraOptions?.surname}`.toUpperCase()
                : ''
            }`
          }}
          singleCol
          handleBlur={handleBlur}
          errors={errorsFormElements}
          setErrors={setErrorsFormElements}
        />
      )}
      <p className="text-sec-red font-alliance-light text-[14px] lg:text-[22px] mt-6 lg:mt-10 mb-20">
        {error}
      </p>
    </div>
  )
}

export default NewPlayer
